import { type FC } from "react";

interface PictureProps {
    webpSrc?: string;
    jpegSrc?: string;
    pngSrc?: string;
    svgSrc?: string;
    alt: string;
    className?: string;
    dataTestId?: string;
}

export const Picture: FC<PictureProps> = ({ webpSrc, jpegSrc, pngSrc, svgSrc, alt, className, dataTestId }) => {
    return (
        <picture data-testid={dataTestId} className={className}>
            {webpSrc && <source srcSet={webpSrc} type="image/webp" />}
            {jpegSrc && <source srcSet={jpegSrc} type="image/jpeg" />}
            {pngSrc && <source srcSet={jpegSrc} type="image/png" />}
            {svgSrc && <source srcSet={svgSrc} type="image/svg+xml" />}
            <img src={svgSrc ?? jpegSrc ?? pngSrc} alt={alt} />
        </picture>
    );
};
